module.exports = __webpack_public_path__ + "static/img/健康档案管理.76996b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/健康档案管理.png
// module id = WM9x
// module chunks = 1